var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center"},[(_vm.label)?_c('label',{staticClass:"form-label mr-2 pt-1",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.label)+":")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bg-gray-200 rounded-full w-12 h-6 relative",on:{"click":_vm.toggle}},[_c('div',{class:[
        _vm.isOn ? 'transform bg-green-500 translate-x-6' : 'bg-gray-500',
        'rounded-full w-6 h-6 absolute top-0 left-0 transition duration-300',
      ]})]),_vm._v(" "),_c('span',{staticClass:"ml-2 text-gray-700"},[_vm._v(_vm._s(_vm.isOn ? "ON" : "OFF"))])])
}
var staticRenderFns = []

export { render, staticRenderFns }